import { Atom } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.span`
  ${({ displayState }) => css`
    svg {
      fill: ${displayState?.color ? displayState?.color : '#1DBD6B'};
    }
  `}
`;

export default Atom({ type: 'label', dataType: 'object', template })